var _jsxFileName = "/codebuild/output/src286223568/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/InputPassword/index.tsx";
import React, { memo } from 'react';
import { PasswordInput } from '@adc/parallax-component-library';
const InputPassword = /*#__PURE__*/memo(({
  isInvalid = false,
  label = '',
  errorMessage,
  placeholder = '',
  mt,
  mb,
  autoComplete = 'current-password',
  onChangeText,
  testID,
  value,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(PasswordInput, Object.assign({
    label: label,
    valid: isInvalid ? 'no' : 'yes',
    ariaLabelExtractor: () => '',
    hideButtonAriaLabelExtractor: () => '',
    autoComplete: autoComplete,
    marginTop: mt,
    marginBottom: mb,
    placeholder: placeholder,
    onChangeText: onChangeText,
    supportingText: isInvalid ? errorMessage : undefined,
    testID: testID
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    value: value
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }));
});
InputPassword.displayName = 'InputPassword';
export { InputPassword };